import {
	Button,
	Flex,
	Icon,
	Menu,
	MenuItem,
	MenuTrigger,
	Popover,
	Text,
} from "@repo/ui";
import { useQuery } from "../db/DatabaseProvider";

type SpecialtyPickerProps = {
	specialtyId: string | undefined;
	onChange?: (specialtyId: string | undefined) => void;
};

export function SpecialtyPicker({
	specialtyId,
	onChange,
}: SpecialtyPickerProps) {
	const specialties = useQuery("specialty", (q) => q, []);

	// Sort specialties alphabetically by name
	const sortedSpecialties = [...specialties].sort((a, b) =>
		a.name.localeCompare(b.name),
	);

	// Find the selected specialty to display its name
	const selectedSpecialty = specialties.find((s) => s.id === specialtyId);
	const displayText = selectedSpecialty
		? `${selectedSpecialty.name} Referral`
		: "Select a specialty";

	return (
		<MenuTrigger>
			<Button variant="ghost" style={{ padding: 0 }}>
				<Flex align="center" gap="xs">
					<Text size="xl" weight="semibold" style={{ userSelect: "none" }}>
						{displayText}
					</Text>
					<Icon name="ChevronDown" size="sm" color="sand11" />
				</Flex>
			</Button>
			<Popover placement="bottom start">
				<Menu>
					{sortedSpecialties.map((specialty) => (
						<MenuItem
							key={specialty.id}
							onAction={() => onChange?.(specialty.id)}
						>
							<Flex gap="xs" flex align="center" justify="space-between">
								<Text size="sm" weight="medium" style={{ userSelect: "none" }}>
									{specialty.name}
								</Text>
								{specialtyId === specialty.id && (
									<Icon name="Check" color="accent9" size="sm" />
								)}
							</Flex>
						</MenuItem>
					))}
				</Menu>
			</Popover>
		</MenuTrigger>
	);
}
